var exports = {
  "e": "TransferOwnershipModal.module__warningBox___TGRzZk",
  "i": "TransferOwnershipModal.module__warningText___TGRzZk",
};

module.exports = exports;
